/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown>, template: NonNullable<unknown> }} Ccsl_Export_File_NameInputs */



/**
* | output |
* | --- |
* | "{title} - CCSL - {template}.docx" |
*
* @param {Ccsl_Export_File_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_file_name = /** @type {((inputs: Ccsl_Export_File_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_File_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.title} - CCSL - ${i?.template}.docx`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.title} – CCSL – ${i?.template}.docx`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.title} - CCSL - ${i?.template}.docx`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.title} – CCSL – ${i?.template}.docx`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.title} - CCSL - ${i?.template}.docx`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.title} - CCSL - ${i?.template}.docx`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.title} - CCSL - ${i?.template}.docx`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.title} - सीसीएसएल - ${i?.template}.docx`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.title} - CCSL - ${i?.template}.docx`)
	return /** @type {LocalizedString} */ (`${i?.title} - CCSL - ${i?.template}.docx`)
});